import Tittle from "./Tittle";
import PropTypes from "prop-types";
import styles from "./AboutSection.module.css";

const AboutSection = ({ className = "" }) => {
  return (
    <div id="sobre-nos" className={[styles.aboutSection, className].join(" ")}>
      <div className={[styles.container, "container"].join(" ")}>
        <div className={styles.logo}>
          <img className={styles.logoIcon} alt="" src="/logo.png" />
        </div>
        <div className={styles.aboutText}>
          <div className={styles.text}>
            <Tittle
              text="Sobre nós"
              mode="claro"
              className={styles.Tittle}
            />
            <p>
              Trabalhamos para proporcionar aos nosso clientes e parceiros,
              tranquilidade e segurança nas operações de transferências de riscos
              patrimoniais, empresariais e residenciais.
              <br />
              Matendo a filosofia: "Sua satisfação é nosso maior benefício!"
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

AboutSection.propTypes = {
  className: PropTypes.string,
};

export default AboutSection;
